export type Review = {
  id: number
  image: string
}

export const reviews: Review[] = [
  {
    id: 1,
    image:
      'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2beb4dfc5dba9abbf69590.jpeg',
  },
  {
    id: 2,
    image:
      'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2beb4de5084c4b71a480f6.jpeg',
  },
  {
    id: 3,
    image:
      'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2beb4dc53e51acc0a537e9.jpeg',
  },
  {
    id: 4,
    image:
      'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2beb4b0b818c92b365375b.jpg',
  },
  {
    id: 5,
    image:
      'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2beb4be5084c4b71a480cc.jpeg',
  },
  {
    id: 6,
    image:
      'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2beb4b0b818c92b3653755.jpeg',
  },
  {
    id: 7,
    image:
      'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2beb4bc53e51acc0a537b0.jpeg',
  },
  {
    id: 8,
    image:
      'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2beb4b0b818c92b3653763.jpeg',
  },
  {
    id: 9,
    image:
      'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2beb4b0b818c92b365375b.jpg',
  },
]
